import { Avatar, Stack, Typography } from '@mui/material';
import { dotDateFormat } from 'Config';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IRecommendationInformation {
  title: string;
  description: string;
  icon: string;
  createDate: Date;
}

export const RecommendationInformation = ({
  title,
  description,
  icon,
  createDate,
}: IRecommendationInformation) => {
  return (
    <Stack
      direction='row'
      gap='16px'
      sx={{
        ml: '20px',
        height: '100%',
      }}
    >
      <Avatar alt='' src={icon} />
      <Stack gap='8px'>
        <Typography variant='body1'>{title}</Typography>
        {createDate && (
          <Typography variant='body5' fontSize='16px !important'>
            {Dictionary[DICTIONARY.Home].userRecommendations.date}{' '}
            {format(new Date(createDate), dotDateFormat)}
          </Typography>
        )}
        <Typography
          variant='body6'
          dangerouslySetInnerHTML={{ __html: description }}
          sx={{
            pr: '20px',
            '&  a': {
              color: 'primary.main',
              fontWeight: 600,
            },
          }}
        />
      </Stack>
    </Stack>
  );
};
